import React, { useEffect, useState } from "react";
import { Container, Form } from "react-bootstrap";
import { useSelector } from "react-redux";
import { apiListInstances } from "../../api/ApiInstance";
import {
  apiGetUserByIdColidee,
  apiSanitizeUser,
  apiUpdateUserByIdColidee,
} from "../../api/ApiUser";
import ComponentMenu from "../../components/layout/ComponentMenu";
import ComponentTitle from "../../components/layout/ComponentTitle";
import { useTranslation } from "react-i18next";

const PageNotifications = () => {
  const { t } = useTranslation();
  const { ReduxUserEmail, ReduxUserIdColidee } = useSelector(
    (state) => state.ReduxUser
  );
  const [instances, setInstances] = useState([]);
  const [blackList, setBlackList] = useState([]);

  const handleAddToBlacklist = async (instanceID) => {
    const newBlacklist = [...blackList];
    newBlacklist.push(instanceID);
    const resBlacklist = await apiUpdateUserByIdColidee(ReduxUserIdColidee, {
      blackList: instanceID,
    });
    if (resBlacklist && resBlacklist.status === 201) {
      setBlackList(newBlacklist);
    }
  };

  const handleRemoveFromBlacklist = async (instanceID) => {
    const newBlacklistCopy = [...blackList];
    const newBlacklist = newBlacklistCopy.filter((item) => item !== instanceID);
    const resBlacklist = await apiSanitizeUser(ReduxUserIdColidee, {
      blackList: instanceID,
    });
    if (resBlacklist && resBlacklist.status === 201) {
      setBlackList(newBlacklist);
    }
  };

  const recupDataUser = async () => {
    const resInstances = await apiListInstances(ReduxUserEmail);
    setInstances(resInstances.data);
    const resUser = await apiGetUserByIdColidee(
      ReduxUserIdColidee,
      "fields=blackList"
    );
    setBlackList(resUser.data.blackList);
  };
  useEffect(() => {
    recupDataUser();
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  return (
    <>
      <ComponentMenu />
      <Container>
        <ComponentTitle title={t("public.PageNotifications.titre")} />
        <p>{t("public.PageNotifications.text")}</p>
        {instances.map((instance, index) => (
          <Form.Check
            id={"intance_" + index}
            key={index}
            type="switch"
            label={instance.entite}
            name={instance._id}
            value={instance.id_plateforme}
            onChange={(e) => {
              blackList.includes(instance._id)
                ? handleRemoveFromBlacklist(instance._id)
                : handleAddToBlacklist(instance._id);
            }}
            checked={blackList.includes(instance._id) ? "" : "checked"}
          />
        ))}
      </Container>
    </>
  );
};

export default PageNotifications;
